export const ToolTipRounded = (props) => {
    return (
        <div className="rounded border-blue border p-2 bg-white text-xxs flex w-full">
            {props.message}
        </div>
    )
}